module.exports = __webpack_public_path__ + "img/fulfillment-mibox.a6ebff0d.svg";